{
  "welcome": {
    "title": "Wisdom Conversations",
    "subtitle": "Choose an AI companion to begin a meaningful dialogue.\nEach brings a unique perspective to your journey.",
    "startConversation": "Start Conversation"
  },
  "companions": {
    "aiGuide": "AI Guide",
    "whatCanYouAsk": "What can you ask?"
  },
  "sidebar": {
    "title": "Chats",
    "aiCompanions": "AI Companions",
    "masters": "Masters",
    "friends": "People",
    "circles": "Circles",
    "recentChats": "RECENT CHATS",
    "personal": "PERSONAL",
    "notepad": "Your personal notepad",
    "online": "Online",
    "startConversation": "Start a conversation",
    "new": "New",
    "youPrefix": "You: ",
    "you": "You",
    "unreadA11y_one": "{{count}} unread message",
    "unreadA11y_other": "{{count}} unread messages",
    "messagesTitle": "Messages",
    "messagesSubtitle": "Direct messages",
    "searchA11y": "Search conversations",
    "yesterday": "Yesterday"
  },
  "chat": {
    "unnamedUser": "User",
    "messagePlaceholder": "Your message…",
    "receiptRead": "Read",
    "receiptSent": "Sent",
    "send": "Send",
    "sendHint": "Enter to send, Shift + Enter for a new line",
    "placeholder": "Write a note...",
    "masterPlaceholder": "Message {{name}}...",
    "friendPlaceholder": "Message {{name}}...",
    "master": "Master",
    "savedMessages": "Saved Messages",
    "notesStored": "Notes are stored locally on this device.",
    "messagesDelivered": "Messages are delivered directly to the master.",
    "aiDisclaimer": "AI responses are generated and may not always be accurate. For emergencies, contact a professional.",
    "demoDisclaimer": "Demo mode — responses are simulated.",
    "jotDown": "Jot down ideas for sessions, reminders, or anything you want to keep for later.",
    "startWith": "Start a conversation with {{name}}. Ask about their practices, schedule, or spiritual guidance.",
    "demoBadge": "DEMO · REAL MESSAGING COMING SOON",
    "typing": {
      "someone": "Someone",
      "one": "{{name}} is typing…",
      "two": "{{name1}} and {{name2}} are typing…",
      "many": "{{count}} people are typing…"
    },
    "date": {
      "today": "Today",
      "yesterday": "Yesterday",
      "unreadDivider": "New messages"
    },
    "empty": {
      "channel": {
        "title": "It's quiet in here",
        "description": "Send the first message — bring the circle to life"
      },
      "message": {
        "title": "No messages yet",
        "description": "Be the first to start the conversation"
      },
      "thread": {
        "title": "No discussion yet",
        "description": "Reply to develop the thought"
      },
      "pinned": {
        "title": "Nothing pinned yet",
        "description": "Pin valuable messages to find them easily later"
      }
    },
    "pinned": {
      "label": "Pinned",
      "fullTitle": "Pinned message",
      "readMore": "Read more",
      "unpin": "Unpin",
      "limitToast": "A message is already pinned. Unpin it first to pin a new one."
    },
    "bounce": {
      "title": "Message held",
      "description": "Your message includes something the community handles with care. Rephrase it and try again.",
      "editAndSend": "Edit & send",
      "sendAnyway": "Send anyway",
      "delete": "Delete",
      "editingTitle": "Edit and resend",
      "editPlaceholder": "Rephrase your message…",
      "send": "Send",
      "sending": "Sending…",
      "cancel": "Cancel"
    },
    "voiceBlocked": {
      "title": "Voice message not sent",
      "description": "It seems this voice message has wording the community handles with care. Record a new one and try again.",
      "ok": "Got it"
    },
    "aboutEvent": "About the live session",
    "archiveNotice": "The live session has ended. These are the messages from its chat.",
    "byMaster": "Hosted by {{name}}",
    "customAmount": "Another amount",
    "defaultDescription": "A live session with {{name}} — come and be here together.",
    "disconnected": "Connection lost",
    "firstMessage": "It is quiet here so far",
    "host": "Host",
    "liveSession": "Live session",
    "offering": "Support",
    "reconnecting": "Reconnecting…",
    "sayHello": "Say hello to the community",
    "thankYou": "Thank you for your support — {{amount}}",
    "time": {
      "now": "just now",
      "minutesAgo": "{{count}} min ago"
    },
    "fragment": {
      "ask": "Ask about this",
      "askAboutPhrase": "Ask about a phrase",
      "pickTitle": "Select a phrase",
      "pickHint": "Select the part of the message you want to ask about.",
      "cancel": "Cancel",
      "originalDeleted": "The original message was deleted"
    }
  },
  "categories": {
    "ai": "AI",
    "masters": "Masters",
    "friends": "Friends",
    "circles": "Circles"
  },
  "wisdomCouncil": {
    "title": "Wisdom Council",
    "subtitle": "Ask the sages",
    "description": "Ask questions to the council. Use @mentions to direct questions to specific sages.",
    "members": "Council Members",
    "starredMessages": "Starred Messages",
    "starredEmpty": "Star messages to save wisdom here",
    "starMessage": "⭐ Star",
    "unstarMessage": "★ Unstar",
    "tabs": {
      "answer": "Answer",
      "links": "Links",
      "media": "Media"
    },
    "devDayMinutes": "1 day ="
  },
  "sidebarEmpty": {
    "noResults": "No results found",
    "noContacts": "No contacts yet",
    "createTestCircle": "Create test circle",
    "devOnlyHint": "dev-only • to test Events"
  },
  "authGate": {
    "title": "Sign in to access Chats",
    "description": "Log in to start conversations with AI companions, masters, friends, and circles.",
    "logIn": "Log In",
    "noAccount": "Don't have an account? Sign Up"
  },
  "moderation": {
    "unmute": "Unmute",
    "mute": "Mute",
    "kick": "Remove from circle",
    "ban": "Ban forever",
    "kickConfirmTitle": "Remove from circle",
    "kickConfirmBody": "Remove {{name}} for sure? They'll lose access to the chat and circle events.",
    "kickWorking": "Removing…",
    "kickConfirm": "Remove",
    "banConfirmTitle": "Ban forever",
    "banConfirmBody": "{{name}} will never be able to come back to the circle. Are you sure?",
    "banWorking": "Banning…",
    "banConfirm": "Ban",
    "mutePickerTitle": "Mute {{name}}",
    "mutePickerBody": "They can't write but stay in the circle and see the content",
    "muteDurations": {
      "h1": "1 hour",
      "h24": "24 hours",
      "d7": "7 days",
      "forever": "Forever"
    },
    "cancel": "Cancel"
  },
  "native": {
    "subtitle": "Closer to kindred spirits",
    "searchPlaceholder": "Search messages",
    "tabs": {
      "all": "All",
      "ai": "AI",
      "people": "People"
    },
    "empty": "No conversations yet",
    "loadFailed": "Couldn't load chats",
    "aiSection": "AI companions",
    "peopleSection": "People",
    "aiFriend": "AI friend",
    "peer": "Contact",
    "draft": "Draft: ",
    "thread": {
      "sendFailBody": "No connection to the chat. Your text is still in the field — try again.",
      "sendFailBodyShort": "No connection to the chat. Please try again.",
      "voiceFailBody": "No connection to the chat. The recording is saved — you can send it again.",
      "voiceFailed": "The voice message wasn't sent",
      "failedTitle": "Couldn't do that",
      "unpinFailed": "Couldn't unpin the message.",
      "pinUnavailable": "Pinning isn't available in this chat (no rights).",
      "fileFailed": "The file wasn't sent",
      "editFailed": "The edit wasn't saved",
      "messageFailed": "The message wasn't sent",
      "reactionFailed": "The reaction wasn't saved",
      "deleteFailed": "The message wasn't deleted",
      "online": "Online",
      "personalDialog": "Direct message",
      "inviteToRoom": "Invite to a Live session",
      "attach": "Attach a file",
      "emoji": "Brand emoji",
      "voice": "Voice message",
      "scrollDown": "Jump to latest",
      "openFailed": "Couldn't open the chat",
      "openFailedHint": "No connection to the message server. Check the internet and try again.",
      "encrypted": "Messages are protected with end-to-end encryption.",
      "photo": "Photo",
      "captionHint": "Add a caption (optional)",
      "editing": "Editing",
      "replyTo": "Reply to {{name}}",
      "attachment": "Attachment",
      "micHint": "Hold to record a voice message",
      "youBlocked": "You have blocked this user",
      "unblock": "Unblock",
      "messageLabel": "Message",
      "composerPlaceholder": "Message...",
      "roomInvite": "Join my live session: {{url}}",
      "inviteFailed": "The invite wasn't sent. Try again from the chat.",
      "clearAllFailed": "Couldn't clear the conversation for everyone. Please try again.",
      "blockRejected": "The server rejected the block",
      "chatKept": "The chat was not deleted.",
      "releaseToCancel": "Release to cancel",
      "swipeToCancel": "‹ swipe to cancel",
      "typing": "typing",
      "removeReaction": "Remove the {{emoji}} reaction",
      "addReaction": "Add the {{emoji}} reaction",
      "voiceRetry": "Retry",
      "voiceDiscard": "Delete"
    },
    "menu": {
      "profile": "Profile",
      "search": "Search",
      "mute": "Mute",
      "unmute": "Unmute",
      "clear": "Clear chat",
      "block": "Block",
      "deleteChat": "Delete conversation",
      "deleteAndBlock": "Delete and block",
      "reply": "Reply",
      "pin": "Pin",
      "deleteForMe": "Delete for me"
    },
    "block": {
      "title": "Block {{name}}?",
      "body": "A blocked person won't be able to write to you.",
      "andDelete": "Block and delete the chat"
    },
    "clear": {
      "title": "Clear the chat?",
      "body": "Choose how to delete the conversation.",
      "selfOnly": "Delete for me only",
      "everyone": "Delete for everyone"
    },
    "confirmRoom": {
      "title": "Do you really want to go to the live session?",
      "yes": "Yes"
    }
  },
  "agapellaSubscriptionOffer": {
    "button": "Get Agapēlla subscription"
  },
  "tour": {
    "replayCta": "Take the platform tour",
    "replayAgain": "Take the platform tour again"
  },
  "preview": {
    "attachment": {
      "voiceRecording": "Voice message",
      "image": "Photo",
      "video": "Video",
      "audio": "Audio",
      "giphy": "GIF",
      "file": "Attachment"
    }
  },
  "thread": {
    "opening": "Opening the conversation…"
  },
  "emptyDialog": {
    "title": "Closer to each other",
    "subtitle": "Choose a conversation on the left to continue",
    "circlesTitle": "Circles",
    "circlesSubtitle": "Choose a circle to open its discussion."
  },
  "aiNotice": {
    "caption": "Replies are generated by AI",
    "link": "AI notice (in Russian)"
  },
  "aiConsentDeclined": {
    "title": "All right, no AI assistant for now",
    "body": "Without your consent the chat with Agapella stays closed and nothing is sent to the AI service. Everything else on the platform works as usual. If you change your mind, you can read the terms again.",
    "readAgain": "Read the terms again"
  }
}
